import WhiteboardSm from '../WhiteboardSm';
import withIntersectionObserver from '../../hoc/index.jsx';

export default withIntersectionObserver(WhiteboardSm);
